"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../../../Button"));
var Routes_1 = require("../../../../constants/Routes");
var globalSlice_1 = require("../../../../features/global/globalSlice");
var loginSlice_1 = require("../../../../features/login/loginSlice");
var userSlice_1 = require("../../../../features/user/userSlice");
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var developer_user_logo_svg_1 = __importDefault(require("../../../../../images/developer-user-logo.svg"));
var individual_user_logo_svg_1 = __importDefault(require("../../../../../images/individual-user-logo.svg"));
var ConfirmModal_1 = __importDefault(require("../../../Modals/ConfirmModal"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ChangeAccountType = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var _a = react_1.useState(false), openChangeAccountModal = _a[0], setOpenChangeAccountModal = _a[1];
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var userRole = react_redux_1.useSelector(userSlice_1.selectUserRole);
    var handleChangeAccount = function () {
        try {
            dispatch(loginSlice_1.logout());
            setOpenChangeAccountModal(!openChangeAccountModal);
            history.push(Routes_1.Routes.Registration.path);
        }
        catch (e) {
            dispatch(globalSlice_1.addToastMessage({
                text: t('Account.Settings.CHANGE_ACCOUNT.ACCOUNT_CHANGING_FAILED'),
                appearance: 'error',
            }));
        }
    };
    var handleCancelChangeAccount = function () {
        setOpenChangeAccountModal(!openChangeAccountModal);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ConfirmModal_1.default, { open: openChangeAccountModal, cancelButtonTitle: t('Account.Settings.CHANGE_ACCOUNT.NO'), confirmButtonTitle: t('Account.Settings.CHANGE_ACCOUNT.DEACTIVATE'), content: t('Account.Settings.CHANGE_ACCOUNT.TEXT'), headerTitle: t('Account.Settings.CHANGE_ACCOUNT.DEACTIVATE_ACCOUNT'), onCancel: handleCancelChangeAccount, onConfirm: handleChangeAccount }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.change_account_type },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.change_account_container },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.change_account_type_image },
                    react_1.default.createElement("img", { src: userRole === GeneralSettings_1.ROLES.INDIVIDUAL
                            ? individual_user_logo_svg_1.default
                            : developer_user_logo_svg_1.default, alt: "Developer or individual" })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                    react_1.default.createElement("h1", { className: styles_module_scss_1.default.content_title }, userRole === GeneralSettings_1.ROLES.INDIVIDUAL
                        ? t('CHANGE_ACCOUNT_TYPE.INDIVIDUAL')
                        : t('CHANGE_ACCOUNT_TYPE.DEVELOPER')),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.content_text }, userRole === GeneralSettings_1.ROLES.INDIVIDUAL
                        ? t('CHANGE_ACCOUNT_TYPE.INDIVIDUAL_TEXT')
                        : t('CHANGE_ACCOUNT_TYPE.DEVELOPER_TEXT')))),
            react_1.default.createElement(Button_1.default, { variant: "outline", className: styles_module_scss_1.default.change_account_type_button, onClick: function () { return setOpenChangeAccountModal(true); } },
                react_1.default.createElement("img", { src: userRole != GeneralSettings_1.ROLES.INDIVIDUAL
                        ? individual_user_logo_svg_1.default
                        : developer_user_logo_svg_1.default, alt: "Developer or individual", className: styles_module_scss_1.default.user_icon }),
                userRole === GeneralSettings_1.ROLES.INDIVIDUAL
                    ? t('CHANGE_ACCOUNT_TYPE.BECOME_DEVELOPER')
                    : t('CHANGE_ACCOUNT_TYPE.BECOME_INDIVIDUAL')))));
};
exports.default = ChangeAccountType;
